<template>
    <div class="dialog">
      <div class="dialog-wraper">
        <div class="dialog-title">
          {{dialogText}}
        </div>
        <div class="text">
          {{dialogMsg}}
        </div>
        <div class="operation">
          <button class="sure" @click="sure">{{ $t('system.confirm') }}</button>
          <!-- <button class="cancel" @click="cancel">取消</button> -->
        </div>
      </div>
    </div>
</template>
<script>
import i18n from '@/i18n'

export default {
    data () {
        return {

        }
    },
    props: {
       dialogText: {
           type: String,
           default: i18n.t('system.remind')
       },
       dialogMsg: {
           type: String,
           default: ''
       }
    },
    methods: {
        sure () {
            this.$emit('sure')
        }

    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99;
        background: rgba(0,0,0,0.85);
        .dialog-wraper{
            width: 400px;
            height: auto;
            min-height: 207px;
            border-top: 4px solid #EA5947;
            border-radius: 4px;
            background: #fff;
            margin: 0 auto;
            margin-top: 254px;
            padding: 30px 42px;
            box-sizing: border-box;
            .dialog-title{
                font-family: PingFangSC-Semibold;
                font-size: 18px;
                color: #444444;
                letter-spacing: 0;
                line-height: 28px;
                font-weight: 700;
            }
            .text{
                font-family: PingFangSC-Regular;
                font-size: 18px;
                color: #444444;
                letter-spacing: 0;
                line-height: 28px;
                margin: 23px 0 30px 0;
            }
            .operation{
                text-align: center;
                .sure{
                    width: 80px;
                    height: 32px;
                    background: #EA5947;
                    border-radius: 4px;
                    outline: none;
                    color: #fff;
                    border: transparent;
                    cursor: pointer;
                    font-size: 16px;
                }
                .cancel{
                    width: 80px;
                    height: 32px;
                    background: #fff;
                    border-radius: 4px;
                    outline: none;
                    color: #969696;
                    border: 1px solid #E3E3E9;
                    cursor: pointer;
                    font-size: 16px;
                    margin-left: 35px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/common/components/dialog/dialog.vue